import {
  useCreateSensorMutation,
  useEditSensorMutation,
  useEnrollSensorMutation,
  useExportSensorLogsMutation,
  useGetRetrieveFromZebraMutation,
  useGetRetrieveFromMonnitMutation,
  useGetSensorLogsMutation,
  useGetSensorMutation,
  useGetSensorsLogMutation,
  useStartSensorMutation,
  useStopSensorMutation,
  useUnEnrollSensorMutation,
  useGetRefrigeratorLogsReportMutation,
} from "../redux/sensor/sensorApiSlice";
import { toast } from "react-toastify";
import { getErrorMessage } from "../utils/commonUtils";

export default function useSensorManagement() {
  const [getSensor, { isLoading: getSensorLoading }] = useGetSensorMutation();
  const [createSensor, { isLoading: createSensorLoading }] = useCreateSensorMutation();
  const [editSensor, { isLoading: editSensorLoading }] = useEditSensorMutation();
  const [enrollSensor, { isLoading: enrollSensorLoading }] = useEnrollSensorMutation();
  const [unEnrollSensor, { isLoading: unEnrollSensorLoading }] = useUnEnrollSensorMutation();
  const [startSensor, { isLoading: startSensorLoading }] = useStartSensorMutation();
  const [stopSensor, { isLoading: stopSensorLoading }] = useStopSensorMutation();
  const [getSensorLogs, { isLoading: getSensorLogsLoading }] = useGetSensorLogsMutation();
  const [getRetrieveFromZebra, { isLoading: getRetrieveFromZebraLoading }] = useGetRetrieveFromZebraMutation();
  const [getRetrieveFromMonnit, { isLoading: getRetrieveFromMonnitLoading }] = useGetRetrieveFromMonnitMutation();
  const [exportSensorLogs, { isLoading: exportSensorLogsLoading }] = useExportSensorLogsMutation();
  const [getSensorsLog, { isLoading: getSensorsLogLoading }] = useGetSensorsLogMutation();
  const [getRefrigeratorLogsReport, { isLoading: getRefrigeratorLogsReportLoading }] = useGetRefrigeratorLogsReportMutation();
  const getSensorListAPI = async (data: any) => {
    try {
      const response = await getSensor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const createSensorAPI = async (data: any) => {
    try {
      const response = await createSensor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const editSensorAPI = async (data: any) => {
    try {
      const response = await editSensor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const enrollSensorAPI = async (data: any) => {
    try {
      const response = await enrollSensor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const unEnrollSensorAPI = async (data: any) => {
    try {
      const response = await unEnrollSensor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const startSensorAPI = async (data: any) => {
    try {
      const response = await startSensor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const stopSensorAPI = async (data: any) => {
    try {
      const response = await stopSensor(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getSensorLogsAPI = async (data: any) => {
    try {
      const response = await getSensorLogs(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getRetrieveFromZebraAPI = async (data: any, isFullRes: boolean = false) => {
    try {
      const response = await getRetrieveFromZebra(data).unwrap();
      return isFullRes ? response : response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getRetrieveFromMonnitAPI = async (data: any, isFullRes: boolean = false) => {
    try {
      const response = await getRetrieveFromMonnit(data).unwrap();
      return isFullRes ? response : response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const exportSensorLogsAPI = async (data: any) => {
    try {
      const response = await exportSensorLogs(data).unwrap();
      toast.success("Success! File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getSensorsLogAPI = async (data: any) => {
    try {
      const response = await getSensorsLog(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getRefrigeratorLogsReportAPI = async (data: any) => {
    try {
      const response = await getRefrigeratorLogsReport(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  //   const deleteTenantAPI = async(data:any) =>{
  //     try {
  //       const response = await deleteTenant(data).unwrap();
  //       toast.success("Successfully deleted tenant.");
  //       return response;
  //     } catch (err: any) {
  //       const message = getErrorMessage(err);
  //       throw new Error(message);
  //     }
  //   }
  return {
    getSensorListAPI,
    getSensorLoading,
    createSensorAPI,
    createSensorLoading,
    editSensorAPI,
    editSensorLoading,
    enrollSensorAPI,
    enrollSensorLoading,
    unEnrollSensorAPI,
    unEnrollSensorLoading,
    startSensorAPI,
    startSensorLoading,
    stopSensorAPI,
    stopSensorLoading,
    getSensorLogsAPI,
    getSensorLogsLoading,
    getRetrieveFromZebraAPI,
    getRetrieveFromZebraLoading,
    getRetrieveFromMonnitAPI,
    getRetrieveFromMonnitLoading,
    exportSensorLogsAPI,
    exportSensorLogsLoading,
    getSensorsLogAPI,
    getSensorsLogLoading,
    getRefrigeratorLogsReportAPI,
    getRefrigeratorLogsReportLoading
  };
}
